import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import ChatTongole from './components/Chat/ChatTongole';

ReactDOM.render(
  <BrowserRouter>
  <ChatTongole/>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);